export default "__VITE_ASSET__hP6dTOdi__"